export enum FiltersRowsEnum {
  COUNTRIES = 'countries',
  GENRES = 'genres',
  QUALITIES = 'qualities',
  YEARS = 'years',
  CINEMAS = 'cinemas',
  YEAR_FROM = 'yearFrom',
  YEAR_TO = 'yearTo',
  IS_FREE = 'isFree',
  IS_SUBTITLE_LOCALE = 'isSubtitleLocales',
  IS_DOWNLOAD = 'isDownload',
  AUDIO_TRACK = 'audioTrack',
  RATING_IMDB = 'ratingImdb',
  RATING_KINOPOISK = 'ratingKP'
}
